import classnames from 'classnames/bind'
import React, { useCallback, useState } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'

import SmallArrow from 'components/icons/SmallArrow'
import ArticleCardHorizontal from 'components/shared/ArticleCardHorizontal'
import { Text } from 'components/typo'
import AuthorContent from '../AuthorContent'
import Layout from '../Layout'

import css from './styles.module.scss'
import fetchContentType from 'src/lib/Strapi/fetchContentType'

const cx = classnames.bind(css)

export default function UserBlogPost({ blogPosts, params }) {
  const [limit] = useState(6)
  const [nextPageData, setNextPageData] = useState(blogPosts)
  const [userBlogPosts, setUserBlogPosts] = useState([])
  const [offset, setOffset] = useState(limit)
  const [isLoadMore, setIsLoadMore] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useIsomorphicLayoutEffect(() => {
    setUserBlogPosts(blogPosts)
  }, [blogPosts])

  useIsomorphicLayoutEffect(() => {
    // Show "Load More" button if the next page has more posts than the limit
    setIsLoadMore(nextPageData && nextPageData.length >= limit)
  }, [nextPageData])

  const handleClickLoadMore = useCallback(async () => {
    setIsLoading(true)

    const newUserBlogPosts = await fetchContentType(
      'blog-posts',
      `${params}&pagination[start]=${offset}&pagination[limit]=${limit}`
    )

    setNextPageData(newUserBlogPosts)
    setUserBlogPosts((prevPosts) => [...prevPosts, ...newUserBlogPosts])

    // Set to show "Load More" only if there are more posts to load
    setIsLoadMore(newUserBlogPosts.length >= limit)

    // Update offset safely in sequence
    setOffset((prevOffset) => prevOffset + limit)
    setIsLoading(false)
  }, [userBlogPosts, params, limit])

  return (
    <div className={css.UserBlogPostWrapper}>
      <Layout type="maxWidth">
        <Layout type="wrapper">
          <AuthorContent {...blogPosts?.[0]?.user.data.attributes} />
          {userBlogPosts && userBlogPosts.length > 0 ? (
            <ul className={css.blogPostsList}>
              {userBlogPosts.map((blog) => (
                <ArticleCardHorizontal
                  key={blog.id}
                  {...blog}
                  link={`/blog/${blog.slug}`}
                />
              ))}
            </ul>
          ) : (
            <div className={css.noResults}>
              <Text>No results</Text>
            </div>
          )}
          {isLoadMore && (
            <div
              className={cx(css.buttonContainer)}
              onClick={handleClickLoadMore}
            >
              <button className={cx(css.button, isLoading && css.loading)}>
                Load More Articles
                <SmallArrow theme="current-color" className={css.smallArrow} />
              </button>
            </div>
          )}
        </Layout>
      </Layout>
    </div>
  )
}
